import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { GlobalSearchCategorySchema } from "./global-search/global-search-category";

const RedoDocumentationSchema_ = z.object({
  _id: zExt.objectId(),
  title: z.string(),
  description: z.string().optional(),
  link: z.string(),
  // Optional icon or image URL for the search result
  iconUrl: z.string().optional(),
  category: GlobalSearchCategorySchema.optional(),
  // Group for organizing search results
  group: z.string().optional(),
  // Search keywords/tags to improve discoverability
  keywords: z.array(z.string()).default([]),
  // Whether this result is active/enabled
  enabled: z.boolean().default(true),
  // Priority/order for display (higher numbers appear first)
  priority: z.number().int().default(0),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const RedoDocumentationSchema: z.ZodType<RedoDocumentation> =
  RedoDocumentationSchema_;
export interface RedoDocumentation
  extends z.infer<typeof RedoDocumentationSchema_> {}

export const CreateRedoDocumentationSchema = RedoDocumentationSchema_.omit({
  _id: true,
  createdAt: true,
  updatedAt: true,
});
export type CreateRedoDocumentation = z.infer<
  typeof CreateRedoDocumentationSchema
>;

export const UpdateRedoDocumentationSchema = RedoDocumentationSchema_.omit({
  _id: true,
  createdAt: true,
  updatedAt: true,
}).partial();
export type UpdateRedoDocumentation = z.infer<
  typeof UpdateRedoDocumentationSchema
>;
